import { useAxiosInstance } from './axiosInstance';
const instance = useAxiosInstance().instance;

export const summaryApi = {
    getSummary(filters) {
        return instance().get(`/summary`, { params: filters });
    }
}